$(document).ready(function() {

  // sticky header
  // $(window).on('scroll load', function() {
  //   var $header = $('.header');
  //   if ($(this).scrollTop() > 200) {
  //     $header.addClass('sticky');
  //   } else {
  //     $header.removeClass('sticky');
  //   }
  // });

  $('.header .hamburger').on('click', function() {
    Menu.open();
  });

  $('.aside-menu__close, .page-overlay').on('click', function() {
    Menu.close();
  });

  // $('.h-search').on('click', function(e) {
  //   e.preventDefault();
  //   if (!$(this).hasClass('is-active')) {
  //     $(this).addClass('is-active');
  //     $('body').addClass('has-search');
  //     $('.searchfield').focus();
  //   } else {
  //     $('.searchfield').val('');
  //     $(this).removeClass('is-active');
  //     $('body').removeClass('has-search');
  //   }
  // });

  $(document).on('click', function(e) {
    if ($(e.target).closest('.header').length === 0) {
      // $('.h-search').removeClass('is-active');
      $('body').removeClass('has-search');
      // $('.searchfield').val('');
    }
    if ($(e.target).closest('.calendar-dropdown').length === 0) {
      $('.calendar-dropdown').removeClass('calendar-active');
    }
    if ($(e.target).closest('.language-dropdown').length === 0) {
      $('.language-dropdown').removeClass('language-active');
    }
  });

  // $('.h-search').addClass('is-active');
  // $('body').addClass('has-search');
  // setTimeout(function() {
  //   $(".tt-input").eq(0).val("star wars").trigger("input").focus();
  //   $(".tt-input").eq(0).focus();
  // }, 400);


  // calendar button

  $('.h-calendar').on('click', function(e) {
    e.preventDefault();
    var dropdown = $('.calendar-dropdown');
    var dropdown2 = $('.language-dropdown');

    if (!dropdown.hasClass('calendar-active')) {
      dropdown.addClass('calendar-active');
    } else {
      dropdown.removeClass('calendar-active');
    }
  });

  $('.h-language').on('click', function(e) {
    e.preventDefault();
    var dropdown = $('.language-dropdown');

    if (!dropdown.hasClass('language-active')) {
      dropdown.addClass('language-active');
    } else {
      dropdown.removeClass('language-active');
    }

  });



  // header search with suggestions
  var events = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('title'),
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    remote: {
      wildcard: '%QUERY',
      url: 'http://api.themoviedb.org/3/search/movie?query=%QUERY&api_key=f22e6ce68f5e5002e71c20bcba477e7d',
      transform: function(response) {
        return $.map(response.results, function(event) {
          return {
            title: event.original_title,
            date: event.release_date,
            image: event.poster_path,
            place: 'Stereo Plaza, г. Киев, пр-т Валерия Лобановского, 119',
            price: 'от 1200 грн.'
          };
        });
      }
    }
  });

  $('.searchfield').typeahead({
    highlight: true
  }, {
    name: 'result',
    limit: 'Infinity',
    source: events,
    display: 'title',
    templates: {
      empty: [empty_suggestion_template()],
      suggestion: function(data) {
        return suggestion_template(data);
      }
    }
  });

  $('.tt-dataset-result').after('<div class="query-more"><a href="/?search=dddd">Все результаты</a></div>');



  $('.window-close').on('click', function() {
    $.magnificPopup.close();
  });

  // header profile menu on click
  $(document).on('click', '.h-profile__avatar', function() {
    var menu = $('.h-profile__menu');
    if (!menu.hasClass('menu-active')) {
      menu.addClass('menu-active');
    } else {
      menu.removeClass('menu-active');
    }
  });

  $(document).on('click', function(e) {
    if ($(e.target).closest('.h-profile').length === 0) {
      $('.h-profile__menu').removeClass('menu-active');
    }
  });

  $('.open-popup').magnificPopup({
    type: 'inline',
    removalDelay: 300,
    mainClass: 'mfp-zoom-in',
    showCloseBtn: false,
    callbacks: mp_callbacks
  });

});


// nav menu dropdown
$(document).on("click", ".nav-dd__button", function () {
  var _ = $(this);
  var li = _.parent();
  var list = _.find(".nav-dd__list");
  if (!li.hasClass("active")) {
    li.addClass("active");
  } else {
    li.removeClass("active");
  }
});

$(document).on("click", function (e) {
  if ($(e.target).closest(".nav-dd").length === 0) {
    $(".nav-dd").removeClass("active");
  }
});
